const initAccordions = ($accordion = $('.js-mobile-accordion, .js-accordion')) => {
    //Hide the inactive sections
    $('.accordion__section').not('.is-current').find('.accordion__body').hide();

    //Get url anchor and open target accordion
    const urlAddress = window.location.href;
    const anchor = urlAddress.indexOf('#') != -1 ? urlAddress.substring(urlAddress.indexOf('#') + 1) : "";

    if (anchor.length) {
        $('#' + anchor).addClass('is-current').find('.accordion__body').slideDown();
    }

    //Handle the show/hide logic
    $accordion.on('click', '.accordion__head', function (event) {
        const $accordionSection = $(this).closest('.accordion__section');
        const $accordionBody = $accordionSection.find('.accordion__body');

        if ($(window).outerWidth(true) >= 1024 && $('body').hasClass('template-index')) {
            return;
        }

        $accordionBody.stop().slideToggle();

        $accordionSection.toggleClass('is-current');

        $accordionSection.siblings().removeClass('is-current')
                .find('.accordion__body').slideUp();

        if ($accordionSection.data('color')) {
            $(`#${$accordionSection.data('section-id')}`).attr('data-color', $accordionSection.data('color'));
        }

        if (!$accordion.find('.is-current').length) {
            $(`#${$accordionSection.data('section-id')}`).attr('data-color', '');
        }
    });
}

initAccordions();
